module.exports = __webpack_public_path__ + "img/18.49c86393.jpg";